export const apiOnlineBotObserver = () => {
  if (typeof window !== 'undefined' && window.newrelic) {
    window.LIFE_CYCLE_EVENT_BUS.once('apionline-bot', () => {
      window.newrelic.setCustomAttribute('apionline-bot', 'true');
    });
  }
};